import { useFormContext, useWatch } from 'react-hook-form'
import { stylesFieldForms } from '../styles'

export function fieldsAritmeticaTransformacaoApiIO() {
  const { control } = useFormContext()

  const acaoSelecionada = useWatch({
    name: 'acoes',
    control
  })

  return {
    styles: stylesFieldForms,
    acaoSelecionada,
    control
  }
}
export type FieldsAritmeticaTransformacaoApiIO = ReturnType<typeof fieldsAritmeticaTransformacaoApiIO>
